<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

import PersonAvatar from "@/components/People/PersonAvatar.vue";
import { useMeStore } from "@/stores/me";

const meStore = useMeStore();

const showUserMenu = ref(false);
const isCustomerAdmin = ref(false);
const toggleButton = ref<HTMLButtonElement | null>(null);

const profile = computed(() => meStore.profile);

const hideUserMenu = () => {
  toggleButton.value?.classList?.remove("button-active");
  showUserMenu.value = false;
};

const toggleShowUserMenu = () => {
  showUserMenu.value = !showUserMenu.value;
};

const logout = () => {
  SessionHelper.logout();
};

defineExpose({ hideUserMenu });

onMounted(async () => {
  isCustomerAdmin.value = await meStore.loadTemporaryCustomerAdmin();
});
</script>

<template>
  <nav v-click-outside="{ handler: 'hideUserMenu' }" class="relative flex flex-col self-stretch max-w-2/3">
    <button
      ref="toggleButton"
      v-button-active-toggle
      class="flex p-6 text-left h-full items-center cursor-pointer"
      :aria-expanded="showUserMenu.toString()"
      aria-controls="menu"
      @click="toggleShowUserMenu"
    >
      <person-avatar
        :person="{
          name: {
            firstName: profile?.name?.firstName,
            lastName: profile?.name?.lastName
          },
          extSysApiUserId: profile.extSysApiUserId
        }"
        :tooltip="false"
        class="sm:pr-4 flex-shrink-0"
      />
      <div class="hidden sm:block font-semibold whitespace-nowrap">
        {{ profile?.name?.firstName }}
      </div>
      <div class="ml-2 sm:ml-4 self-center">
        <svg
          class="fill-current opacity-50 w-2 transition-transform ease-out duration-200 rotate"
          viewBox="0 0 12 7"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M11 0L6 4 1 0 0 1l6 6 6-6-1-1z" />
        </svg>
      </div>
    </button>

    <ul
      v-if="showUserMenu"
      id="menu"
      role="menu"
      class="absolute bg-white text-black z-30 right-0 mr-px overflow-x-visible shadow-lg h-auto"
      style="top: 100%; width: fit-content"
      user-menu-container
    >
      <li class="bg-white flex flex-col text-black shadow-2xl w-50" role="menuitem">
        <button
          class="p-4 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none text-16 text-gray-800 font-semibold hover:underline"
          @click="logout"
        >
          Log ud
        </button>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
button.button-active .rotate {
  transform: rotate(-180deg);
}

[user-menu-container]::after {
  content: "";
  display: table;
  clear: both;
}
</style>
